import { Package, ShieldCheck, Tv, ArrowRight } from "lucide-react";
import SectionHeading from "../components/SectionHeading";
import GridTexture from "../components/GridTexture";
import Reveal from "../components/Reveal";

const STEPS = [
  {
    icon: Package,
    title: "Kies Jouw Pakket",
    text: "Selecteer het abonnement dat het beste bij je past — van Basis tot Lifetime.",
  },
  {
    icon: ShieldCheck,
    title: "Betaal Veilig",
    text: "Reken snel en veilig af via iDEAL, Bancontact of je favoriete kaart.",
  },
  {
    icon: Tv,
    title: "Start Direct",
    text: "Ontvang je inloggegevens binnen enkele minuten en begin met kijken.",
  },
];

export default function How() {
  return (
    <section className="py-14 sm:py-20 bg-surface-primary relative overflow-hidden" style={{ "--section-bg": "#000000" }}>
      <GridTexture />
      <div className="main-content w-[90%] sm:w-[90%] md:w-[85%] m-auto relative">
        <SectionHeading
          kicker="Hoe het werkt"
          title={
            <>
              Eenvoudig Abonneren &amp;{" "}
              <span className="text-transparent bg-clip-text bg-gradient-text">
                Direct Toegang
              </span>
            </>
          }
          subtitle="Het proces is eenvoudig en snel. Kies je pakket, rond de betaling af en ontvang direct toegang tot al onze premium content."
        />

        <div className="relative grid sm:grid-cols-3 gap-10 sm:gap-6 mt-6 sm:mt-8">
          {/* Connecting rail — desktop only */}
          <div className="hidden sm:block absolute top-8 left-[16.66%] right-[16.66%] h-px bg-gradient-button opacity-40" />

          {STEPS.map((step, i) => (
            <Reveal key={step.title} delay={i * 120} className="relative flex flex-col items-center text-center">
              <div className="relative z-10 w-16 h-16 rounded-2xl bg-gradient-button p-[2px] shadow-glow-purple-sm mb-5">
                <div className="w-full h-full rounded-[14px] bg-surface-primary flex items-center justify-center">
                  <step.icon className="w-7 h-7 text-white" />
                </div>
              </div>
              <span className="text-[11px] font-black tracking-[0.25em] text-accent mb-2">
                STAP {i + 1}
              </span>
              <h3 className="text-lg sm:text-xl font-black text-white mb-2">{step.title}</h3>
              <p className="text-ink-secondary text-xs sm:text-sm leading-relaxed max-w-[15rem]">
                {step.text}
              </p>
            </Reveal>
          ))}
        </div>

        <Reveal className="flex flex-col items-center mt-10 sm:mt-14">
          <a
            href="#pricing"
            className="inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-xl text-white font-bold bg-gradient-button hover:brightness-110 hover:scale-105 transition-all duration-300 shadow-glow-purple-sm min-h-[48px]"
          >
            Nu Beginnen
            <ArrowRight className="w-5 h-5" />
          </a>
          <p className="mt-3 text-xs text-ink-muted">
            Geen verplichtingen · Annuleer wanneer je wilt · 24/7 Support
          </p>
        </Reveal>
      </div>
    </section>
  );
}
